import React from "react"
import { Layout, Button } from "antd"
import { PictureOutlined, MessageOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import { useWindowWidth } from "./useWindowWidth"

const { Header, Content, Footer } = Layout

interface Props {
  children: React.ReactNode
}

export default function PageLayout({ children }: Props) {
  const navigate = useNavigate()
  const isMobile = useWindowWidth() < 768
  return (
    <Layout style={{ minHeight: "100vh", background: "#f0f2f5" }}>
      <Header
        style={{
          background: "linear-gradient(135deg, #1677ff 0%, #0958d9 100%)",
          borderBottom: "1px solid #1554c7",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          padding: isMobile ? "0 14px" : "0 32px",
          height: isMobile ? 60 : 80,
          boxShadow: "0 2px 8px rgba(22,119,255,0.25)",
          
          top: 0,
          zIndex: 100,
        }}
      >
        {/* left: icon */}
        <div style={{ display: "flex", alignItems: "center", minWidth: isMobile ? 36 : 160 }}>
          <PictureOutlined
            style={{ color: "#fff", fontSize: isMobile ? 26 : 36, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </div>

        {/* center: title */}
        <div
          style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, cursor: "pointer", flex: 1 }}
          onClick={() => navigate("/")}
        >
          <span style={{ color: "#ffffff", fontSize: isMobile ? 15 : 30, fontWeight: 800, letterSpacing: 0.5, lineHeight: 1.2, textAlign: "center" }}>
            Make Your Own Passport Photos
          </span>
          {!isMobile && (
            <span
              style={{
                color: "rgba(255,255,255,0.65)",
                fontSize: 12,
                letterSpacing: 2,
                textTransform: "uppercase",
                lineHeight: 1.2,
              }}
            >
              Remove Backgrounds · Adjust · Crop · Download
            </span>
          )}
        </div>

        {/* right: Leave Feedback button */}
        <div style={{ display: "flex", justifyContent: "flex-end", minWidth: isMobile ? 36 : 160 }}>
          <Button
            icon={<MessageOutlined />}
            onClick={() => navigate("/feedback")}
            style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.4)", color: "#fff", padding: isMobile ? "0 10px" : undefined }}
          >
            {!isMobile && "Leave Feedback"}
          </Button>
        </div>
      </Header>

      <Content style={{ padding: isMobile ? "14px 12px" : "28px 32px", maxWidth: 1400, margin: "0 auto", width: "100%" }}>
        {children}
      </Content>

      <Footer
        style={{
          textAlign: "center",
          background: "#f0f2f5",
          borderTop: "1px solid #e0e0e0",
          padding: "20px 32px",
          color: "#888",
          fontSize: 13,
          lineHeight: 1.8,
        }}
      >
        <p style={{ margin: 0 }}>I hope you find this tool helpful. Please consider leaving <a href="/feedback">feedback</a>.</p>
      </Footer>
    </Layout>
  )
}
